import {
  MANAGE_PAYMENT_OPTIONS_SUCCESS, MANAGE_PAYMENT_OPTIONS_ERROR, MANAGE_PAYMENT_OPTIONS_LOADING,
  SAVE_SUSPEND_PREPAY_OPTIONS_LOADING, SAVE_SUSPEND_PREPAY_OPTIONS_SUCCESS, SAVE_SUSPEND_PREPAY_OPTIONS_ERROR,
  UPDATE_MANAGE_PAYMENTS_PAYMENT_INFO_ERRORS,
  UPDATE_ACCOUNT_PAYMENT_OPTIONS_LOADING,
  UPDATE_ACCOUNT_PAYMENT_OPTIONS_SUCCESS,
  UPDATE_ACCOUNT_PAYMENT_OPTIONS_ERROR,
} from 'constants/ActionTypes';
import { getAccountSummarySaga, getBillingInformationSaga } from 'features/userData/UserData.saga';
import {
  call, put, all, select,
} from 'lib/redux';
import { scrollToTop } from 'utils/app.utils';
import getNextPlanLevelService from 'services/getNextPlanLevel.service';
import saveManagePaymentOptionsService from 'services/saveManagePaymentOptions.service';
import updateAccountPaymentOptionsService from 'services/updateAccountPaymentOptions.service';
import { getCardDataFromPaymentInfo } from 'features/billingInfomation/BillingInformation.util';
import { SUBMIT_PAYMENT_OPTION_SUCCESS_ROUTE } from 'constants/RouteConstants';
import history from 'store/CreateHistory';
import { logError } from 'utils/logger.utils';
import { PAYMENT_OPTIONS_INDEX } from './ManagePaymentOptions.constants';
import { getPaymentInfoValidationErrors } from './ManagePaymentOptions.utils';

export function* loadManagePaymentOptionsSaga() {
  try {
    yield put({ type: MANAGE_PAYMENT_OPTIONS_LOADING });
    yield all([
      call(getBillingInformationSaga),
      call(getAccountSummarySaga),
    ]);

    const nextPlanLevelResponse = yield call(getNextPlanLevelService);

    if (!nextPlanLevelResponse.ok) {
      const error = new Error(nextPlanLevelResponse.json.errorDescription);
      error.errorCode = nextPlanLevelResponse.json.errorCode;
      throw error;
    }

    yield put({
      type: MANAGE_PAYMENT_OPTIONS_SUCCESS, nextPlanLevel: nextPlanLevelResponse.json,
    });
  } catch (error) {
    logError('Error in loadManagePaymentOptionsSaga', {
      error: error.message,
      errorCode: error.errorCode,
    });
    yield put({ type: MANAGE_PAYMENT_OPTIONS_ERROR });
  }
}

export function* saveManagePaymentOptionsSaga() {
  try {
    yield put({ type: SAVE_SUSPEND_PREPAY_OPTIONS_LOADING });

    const { suspendMonthlyPrepay } = yield select(({ managePaymentOptions }) => managePaymentOptions);

    const response = yield call(saveManagePaymentOptionsService, suspendMonthlyPrepay);
    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    yield put({ type: SAVE_SUSPEND_PREPAY_OPTIONS_SUCCESS });
    yield getAccountSummarySaga({ isUpdated: true });
    scrollToTop();
  } catch (error) {
    yield put({ type: SAVE_SUSPEND_PREPAY_OPTIONS_ERROR });
  }
}

export function* updateAccountPaymentOptionsSaga({
  paymentType, paymentInfo, ccConsent, transientTokenData,
}) {
  try {
    yield put({ type: UPDATE_ACCOUNT_PAYMENT_OPTIONS_LOADING });

    if (paymentInfo.isUpdated) {
      const paymentValidationErrors = getPaymentInfoValidationErrors(paymentInfo, ccConsent, transientTokenData);
      yield put({ type: UPDATE_MANAGE_PAYMENTS_PAYMENT_INFO_ERRORS, paymentValidationErrors });
      if (paymentValidationErrors.isError) {
        yield put({ type: UPDATE_ACCOUNT_PAYMENT_OPTIONS_ERROR });
        scrollToTop();
        return;
      }
    }
    const cardData = {
      ...getCardDataFromPaymentInfo(paymentInfo),
      ...(transientTokenData.isCardNumberUpdated && { transientToken: transientTokenData.transientToken }),
    };

    const { paymentValues, purchaseOrder } = yield select(({ managePaymentOptions }) => managePaymentOptions);
    const requestBody = {
      cardData,
      saveCard: ccConsent,
      amount: Number(parseFloat(paymentValues[paymentType]).toFixed(2)),
      ...(paymentType === PAYMENT_OPTIONS_INDEX[0] && { poNumber: purchaseOrder }),
    };

    const response = yield call(updateAccountPaymentOptionsService, paymentType, requestBody);
    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    yield put({ type: UPDATE_ACCOUNT_PAYMENT_OPTIONS_SUCCESS, accountUpdateSuccess: response.json });
    history.push(SUBMIT_PAYMENT_OPTION_SUCCESS_ROUTE);
    yield getAccountSummarySaga({ isUpdated: true });
  } catch (error) {
    yield put({ type: UPDATE_ACCOUNT_PAYMENT_OPTIONS_ERROR });
    scrollToTop();
  }
}
